package com.sweetlime.bingeamigo

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import org.jetbrains.compose.ui.tooling.preview.Preview
import cafe.adriel.voyager.navigator.Navigator
import com.sweetlime.bingeamigo.presentation.features.splash.SplashScreen
import com.sweetlime.bingeamigo.presentation.ui.BrandColors
import io.kamel.image.config.LocalKamelConfig

@Composable
@Preview
fun App() {
    CompositionLocalProvider(LocalKamelConfig provides customKamelConfig) {
        Box(Modifier.fillMaxSize().background(BrandColors.Background)) {
            Navigator(SplashScreen())
        }
    }
}